module.exports = __webpack_public_path__ + "img/Pinterest.912535f2.png";